const messages = {
  ca: {
    translations: {
      signup: {
        title: "Registre",
        toasts: {
          success:
            "L'usuari s'ha creat correctament! Ara podeu iniciar sessió!",
          fail: "Error creant l'usuari. Verifiqueu les dades informades.",
        },
        form: {
          name: "Nom",
          email: "Correu Electrònic",
          password: "Contrasenya",
        },
        buttons: {
          submit: "Registra't",
          login: "Ja teniu un compte? Inicieu sessió!",
        },
      },
      login: {
        title: "Inici de Sessió",
        form: {
          email: "Correu Electrònic",
          password: "Contrasenya",
        },
        buttons: {
          submit: "Entra",
          register: "No teniu compte? Registreu-vos!",
        },
      },
      auth: {
        toasts: {
          success: "Inici de sessió correcte!",
        },
      },
      dashboard: {
        charts: {
          perDay: {
            title: "Tiquets avui: ",
          },
        },
        messages: {
          inAttendance: {
            title: "En servei",
          },
          waiting: {
            title: "Esperant",
          },
          closed: { title: "Finalitzat" },
          byUser: {
            title: "Tiquets per Empleat",
          },
          byQueue: {
            title: "Tiquets per Departament",
          },
          userColumn: "Empleat",
          queueColumn: "Departament",
          openColumn: "En servei",
          pendingColumn: "Esperant",
          closedTodayColumn: "Avui",
          totalColumn: "Total",
          noUsers: "Sense empleats",
          noQueues: "Sense departaments",
        },
      },
      connections: {
        title: "Connexions",
        toasts: {
          deleted: "La connexió de WhatsApp s'ha eliminat correctament!",
        },
        confirmationModal: {
          deleteTitle: "Eliminar",
          deleteMessage: "N'esteu segur? Aquest procés no es pot desfer.",
          disconnectTitle: "Desconnectar",
          disconnectMessage:
            "N'esteu segur? Caldrà tornar a escanejar el codi QR.",
        },
        buttons: {
          add: "Afegeix WhatsApp",
          disconnect: "Desconnectar",
          tryAgain: "Torna-ho a provar",
          qrcode: "CODI QR",
          newQr: "Nou CODI QR",
          connecting: "Connectant",
        },
        toolTips: {
          disconnected: {
            title: "No s'ha pogut iniciar la sessió de WhatsApp",
            content:
              "Assegureu-vos que el vostre telèfon estigui connectat a Internet i torneu-ho a provar o demaneu un nou codi QR.",
          },
          qrcode: {
            title: "Esperant la lectura del codi QR",
            content:
              "Feu clic al botó 'CODI QR' i escanegeu el codi QR amb el vostre mòbil per iniciar la sessió.",
          },
          connected: {
            title: "Connexió establerta",
          },
          timeout: {
            title: "S'ha perdut la connexió amb el telèfon",
            content:
              "Assegureu-vos que el telèfon estigui connectat a Internet i que WhatsApp estigui obert, o feu clic a 'Desconnectar' per obtenir un nou codi QR.",
          },
        },
        table: {
          name: "Nom",
          status: "Estat",
          lastUpdate: "Última Actualització",
          default: "Per Defecte",
          farewellMessage: "Missatge de comiat",
          actions: "Accions",
          session: "Sessió",
        },
      },
      whatsappModal: {
        title: {
          add: "Afegeix WhatsApp",
          edit: "Edita WhatsApp",
        },
        form: {
          name: "Nom",
          default: "Per Defecte",
        },
        buttons: {
          okAdd: "Afegir",
          okEdit: "Desar",
          cancel: "Cancel·lar",
        },
        success: "WhatsApp desat correctament.",
      },
      qrCode: {
        message: "Escanegeu el codi QR per començar la sessió.",
      },
      contacts: {
        title: "Contactes",
        toasts: {
          deleted: "Contacte eliminat correctament!",
        },
        searchPlaceholder: "Cercar...",
        confirmationModal: {
          deleteTitle: "Eliminar",
          importTitlte: "Importar contactes",
          deleteMessage:
            "N'esteu segur que voleu eliminar aquest contacte? Es perdran tots els tiquets associats.",
          importMessage:
            "Voleu importar tots els contactes des del vostre telèfon?",
        },
        buttons: {
          import: "Importar Contactes",
          add: "Afegir Contacte",
        },
        table: {
          name: "Nom",
          whatsapp: "WhatsApp",
          email: "Correu Electrònic",
          actions: "Accions",
        },
      },
      contactModal: {
        title: {
          add: "Afegir contacte",
          edit: "Editar contacte",
        },
        form: {
          mainInfo: "Detalls del contacte",
          extraInfo: "Informació addicional",
          name: "Nom",
          number: "Número de WhatsApp",
          email: "Correu Electrònic",
          extraName: "Nom del Camp",
          extraValue: "Valor",
        },
        buttons: {
          addExtraInfo: "Afegir informació",
          okAdd: "Afegir",
          okEdit: "Desar",
          cancel: "Cancel·lar",
        },
        success: "Contacte desat correctament.",
      },
      quickAnswersModal: {
        title: {
          add: "Afegir resposta ràpida",
          edit: "Editar resposta ràpida",
        },
        form: {
          shortcut: "Drecera",
          message: "Resposta ràpida",
        },
        buttons: {
          okAdd: "Afegir",
          okEdit: "Desar",
          cancel: "Cancel·lar",
        },
        success: "Resposta ràpida desada correctament.",
      },
      queueModal: {
        title: {
          add: "Afegir cua",
          edit: "Editar cua",
        },
        form: {
          name: "Nom",
          color: "Color",
          greetingMessage: "Missatge de salutació",
        },
        buttons: {
          okAdd: "Afegir",
          okEdit: "Desar",
          cancel: "Cancel·lar",
        },
      },
      userModal: {
        title: {
          add: "Afegir usuari",
          edit: "Editar usuari",
        },
        form: {
          name: "Nom",
          email: "Correu Electrònic",
          password: "Contrasenya",
          profile: "Perfil",
          whatsapp: "Connexió estàndard",
        },
        buttons: {
          okAdd: "Afegir",
          okEdit: "Desar",
          cancel: "Cancel·lar",
        },
        success: "Usuari desat correctament.",
      },
      chat: {
        noTicketMessage: "Seleccioneu un tiquet per començar a xatejar.",
      },
      ticketsManager: {
        buttons: {
          newTicket: "Nou",
        },
      },
      ticketsQueueSelect: {
        placeholder: "Cues",
      },
      tickets: {
        toasts: {
          deleted: "El tiquet s'ha eliminat correctament.",
        },
        notification: {
          message: "Missatge de",
        },
        tabs: {
          open: { title: "Bústia" },
          closed: { title: "Resolts" },
          search: { title: "Cercar" },
        },
        search: {
          placeholder: "Cercar tiquets i missatges.",
        },
        buttons: {
          showAll: "Tots",
        },
      },
      transferTicketModal: {
        title: "Transferir Tiquet",
        fieldLabel: "Escriviu per cercar usuaris",
        fieldQueueLabel: "Transferir a la cua",
        fieldConnectionLabel: "Transferir a la connexió",
        fieldQueuePlaceholder: "Seleccioneu una cua",
        fieldConnectionPlaceholder: "Seleccioneu una connexió",
        noOptions: "No s'han trobat usuaris amb aquest nom",
        buttons: {
          ok: "Transferir",
          cancel: "Cancel·lar",
        },
      },
      ticketsList: {
        pendingHeader: "Cua",
        assignedHeader: "Treballant en",
        noTicketsTitle: "Cap tiquet!",
        connectionTitle: "Connexió que s'està utilitzant actualment.",
        noTicketsMessage:
          "No s'han trobat tiquets amb aquest estat o cerca.",
        buttons: {
          accept: "Acceptar",
        },
      },
      newTicketModal: {
        title: "Crear Tiquet",
        fieldLabel: "Escriviu per cercar un contacte",
        add: "Afegir",
        buttons: {
          ok: "Desar",
          cancel: "Cancel·lar",
        },
      },
      mainDrawer: {
        listItems: {
          dashboard: "Panell",
          connections: "Connexions",
          tickets: "Tiquets",
          contacts: "Contactes",
          quickAnswers: "Respostes ràpides",
          reports: "Facturació / Hores",
          queues: "Cues",
          administration: "Administració",
          users: "Usuaris",
          settings: "Configuració",
        },
        appBar: {
          user: {
            profile: "Perfil",
            logout: "Tancar Sessió",
          },
        },
      },
      notifications: {
        noTickets: "Sense notificacions.",
      },
      queues: {
        title: "Cues",
        table: {
          name: "Nom",
          color: "Color",
          greeting: "Missatge de salutació",
          actions: "Accions",
        },
        buttons: {
          add: "Afegir cua",
        },
        confirmationModal: {
          deleteTitle: "Eliminar",
          deleteMessage:
            "N'esteu segur? Aquesta acció no es pot desfer. Els tiquets d'aquesta cua continuaran existint, però sense cua assignada.",
        },
      },
      queueSelect: {
        inputLabel: "Cues",
      },
      quickAnswers: {
        title: "Respostes ràpides",
        table: {
          shortcut: "Drecera",
          message: "Resposta ràpida",
          actions: "Accions",
        },
        buttons: {
          add: "Afegir resposta ràpida",
        },
        toasts: {
          deleted: "Resposta ràpida eliminada correctament",
        },
        searchPlaceholder: "Cercar ...",
        confirmationModal: {
          deleteTitle:
            "Segur que voleu eliminar aquesta resposta ràpida?",
          deleteMessage: "Aquesta acció no es pot desfer.",
        },
      },
      users: {
        title: "Usuaris",
        table: {
          name: "Nom",
          email: "Correu Electrònic",
          profile: "Perfil",
          whatsapp: "Connexió estàndard",
          actions: "Accions",
        },
        buttons: {
          add: "Afegir usuari",
        },
        toasts: {
          deleted: "Usuari eliminat correctament.",
        },
        confirmationModal: {
          deleteTitle: "Eliminar",
          deleteMessage:
            "Tota la informació de l'usuari es perdrà. Els seus tiquets oberts tornaran a la cua.",
        },
      },
      settings: {
        success: "Configuració desada correctament.",
        title: "Configuració",
        settings: {
          userCreation: {
            name: "Creació d'usuaris",
            options: {
              enabled: "Habilitat",
              disabled: "Deshabilitat",
            },
          },
        },
      },
      messagesList: {
        header: {
          assignedTo: "Assignat a:",
          buttons: {
            return: "Retornar",
            resolve: "Resoldre",
            reopen: "Reobrir",
            accept: "Acceptar",
          },
        },
      },
      messagesInput: {
        placeholderOpen:
          "Escriviu un missatge o premeu '/' per utilitzar respostes ràpides",
        placeholderClosed:
          "Reobriu o accepteu aquest tiquet per enviar un missatge.",
        signMessage: "Signar",
      },
      contactDrawer: {
        header: "Detalls del contacte",
        buttons: {
          edit: "Editar contacte",
        },
        extraInfo: "Altra informació",
      },
      ticketOptionsMenu: {
        delete: "Eliminar",
        transfer: "Transferir",
        confirmationModal: {
          title: "Eliminar tiquet #",
          titleFrom: "del contacte ",
          message:
            "Atenció! Es perdran tots els missatges relacionats amb el tiquet.",
        },
        buttons: {
          delete: "Eliminar",
          cancel: "Cancel·lar",
        },
      },
      confirmationModal: {
        buttons: {
          confirm: "D'acord",
          cancel: "Cancel·lar",
        },
      },
      messageOptionsMenu: {
        delete: "Eliminar",
        reply: "Respondre",
        confirmationModal: {
          title: "Eliminar missatge?",
          message: "Aquesta acció no es pot desfer.",
        },
      },
      attendanceReport: {
        title: "Facturació i Registre d'Hores",
        filters: {
          from: "Des de",
          to: "Fins a",
          status: "Estat",
          onlyClosed: "Només Resolts",
          allTickets: "Tots els Tiquets",
          searchLabel: "Cercar client / telèfon",
          searchPlaceholder: "Nom o núm. telèfon",
          filterButton: "Filtrar",
          exportButton: "Exportar CSV",
        },
        kpis: {
          totalTime: "Temps Total Facturable",
          clientsServed: "Clients Atesos",
          clientsUnit: "clients",
          interventions: "Intervencions / Assistències",
          attendancesUnit: "assistències",
          hoursUnit: "hores",
        },
        tabs: {
          summary: "Resum per Client (Facturació)",
          detail: "Detall d'Intervencions",
        },
        summaryTable: {
          client: "Client",
          phone: "Telèfon WhatsApp",
          ticketsCount: "Núm. Assistències",
          totalTime: "Temps Total Dedicat",
          billableHours: "Hores Facturables (Decimal)",
          ticketUnit: "tiquet",
          ticketsUnit: "tiquets",
          noData:
            "No s'han trobat assistències tancades en el període seleccionat.",
        },
        detailTable: {
          ticket: "Tiquet #",
          client: "Client",
          technician: "Tècnic",
          start: "Inici",
          resolution: "Resolució",
          duration: "Temps Dedicat",
          billableHours: "Hores Facturables",
          lastMessage: "Últim Missatge",
          noData: "No s'han trobat intervencions en aquest període.",
        },
        toasts: {
          downloadSuccess: "Informe descarregat amb èxit",
        },
      },
      backendErrors: {
        ERR_NO_OTHER_WHATSAPP:
          "Hi ha d'haver almenys una connexió de WhatsApp per defecte.",
        ERR_NO_DEF_WAPP_FOUND:
          "No s'ha trobat cap connexió per defecte. Verifiqueu la pàgina de connexions.",
        ERR_WAPP_NOT_INITIALIZED:
          "Aquesta sessió de WhatsApp no està inicialitzada. Verifiqueu les connexions.",
        ERR_WAPP_CHECK_CONTACT:
          "No s'ha pogut verificar el contacte de WhatsApp.",
        ERR_WAPP_INVALID_CONTACT: "Aquest no és un número de WhatsApp vàlid.",
        ERR_WAPP_DOWNLOAD_MEDIA:
          "No s'han pogut descarregar els arxius multimèdia de WhatsApp.",
        ERR_INVALID_CREDENTIALS: "Correu electrònic o contrasenya incorrectes. Verifiqueu les dades.",
        ERR_SENDING_WAPP_MSG:
          "Error en enviar el missatge de WhatsApp. Verifiqueu la connexió.",
        ERR_DELETE_WAPP_MSG: "No s'ha pogut eliminar el missatge de WhatsApp.",
        ERR_OTHER_OPEN_TICKET: "Ja hi ha un tiquet obert per a aquest contacte.",
        ERR_SESSION_EXPIRED: "Sessió caducada. Si us plau, inicieu sessió.",
        ERR_USER_CREATION_DISABLED:
          "La creació d'usuaris ha estat desactivada per l'administrador.",
        ERR_NO_PERMISSION: "No teniu permís per accedir a aquest recurs.",
        ERR_DUPLICATED_CONTACT: "Ja existeix un contacte amb aquest número.",
        ERR_NO_SETTING_FOUND: "No s'ha trobat la configuració amb aquest ID.",
        ERR_NO_CONTACT_FOUND: "No s'ha trobat el contacte amb aquest ID.",
        ERR_NO_TICKET_FOUND: "No s'ha trobat el tiquet amb aquest ID.",
        ERR_NO_USER_FOUND: "No s'ha trobat l'usuari amb aquest ID.",
        ERR_NO_WAPP_FOUND: "No s'ha trobat el WhatsApp amb aquest ID.",
        ERR_CREATING_MESSAGE: "Error en crear el missatge a la base de dades.",
        ERR_CREATING_TICKET: "Error en crear el tiquet a la base de dades.",
        ERR_FETCH_WAPP_MSG:
          "Error en obtenir el missatge a WhatsApp, potser és massa antic.",
        ERR_QUEUE_COLOR_ALREADY_EXISTS:
          "Aquest color ja està en ús, trieu-ne un altre.",
        ERR_WAPP_GREETING_REQUIRED:
          "El missatge de salutació és obligatori quan hi ha més d'una cua.",
      },
    },
  },
};

export { messages };
